// # interfaces
import { iPoll } from "@/interfaces/polls";
// # policies
import { PollPolicy } from "@/policies";
// # services
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").service("Polls", polls);

  polls.$inject = ["modalService"];

  function polls(modalService) {
    /**
     * Shows a modal allowing a user to create new or manage an existing poll
     * @param  {number} pollId - (optional) Manage this poll, or undefined/null to create a new poll
     * @return {{ result: Promise<void | iPoll> }} - modalService object containing result.then()
     */
    function managePoll(pollId?: number): { result: Promise<void | iPoll> } {
      const result = new Promise<void | iPoll>((resolve, reject) => {
        if (!pollId && !PollPolicy.canCreate(auth.user())) {
          return reject("Cannot create poll: permission denied.");
        }

        modalService
          .open({
            templateUrl: "modals/manage-poll.html",
            controller: "managePollController",
            controllerAs: "vm",
            windowClass: "manage-poll",
            resolve: {
              pollId: () => pollId,
            },
          })
          .result.then(resolve)
          .catch(reject);
      });

      return { result };
    }

    return {
      managePoll,
    };
  }
})(angular);
